module.exports = __webpack_public_path__ + "static/img/active_hb2.8f565c6a.png";